export default __webpack_public_path__ + "static/media/S2-Traits.d14d4a6e.png";